import React from "react";

/**
 * Compact status chip rendered next to the lead address. Color comes from
 * the configured status (e.g. "teal", "amber", "rose", …); falls back to a
 * neutral pill when the lead has no status label.
 */
const COLOR_MAP = {
  teal:    { bg: "bg-[var(--teal-100,#D8EDEB)]",   text: "text-[var(--teal-800)]",  border: "border-[var(--teal-300,#86c9c2)]" },
  sand:    { bg: "bg-[var(--sand-100)]",            text: "text-[#5A3F0B]",          border: "border-[#D8B883]" },
  amber:   { bg: "bg-[#FAF1DD]",                    text: "text-[#5A3F0B]",          border: "border-[#E5C9A0]" },
  warn:    { bg: "bg-[#FAF1DD]",                    text: "text-[#5A3F0B]",          border: "border-[#E5C9A0]" },
  rose:    { bg: "bg-[#FBE7E7]",                    text: "text-[#7B2424]",          border: "border-[#EFBABA]" },
  red:     { bg: "bg-[#FBE7E7]",                    text: "text-[#7B2424]",          border: "border-[#EFBABA]" },
  green:   { bg: "bg-[#E6F4EC]",                    text: "text-[#1F8B5F]",          border: "border-[#A6D8B7]" },
  blue:    { bg: "bg-[#E2ECF7]",                    text: "text-[#1F4F8B]",          border: "border-[#A6BFDA]" },
  purple:  { bg: "bg-[#EFE5F5]",                    text: "text-[#5C3A78]",          border: "border-[#C8A8DA]" },
  pink:    { bg: "bg-[#FCE4EE]",                    text: "text-[#923660]",          border: "border-[#E8AECA]" },
  slate:   { bg: "bg-[var(--sand-100)]",            text: "text-[var(--ink-700)]",   border: "border-[var(--border-soft)]" },
  ink:     { bg: "bg-[var(--ink-900)]",             text: "text-white",              border: "border-transparent" },
};

export default function StatusChip({ lead, size = "sm" }) {
  const label = lead?.status_label || lead?.status || null;
  if (!label) return null;
  const color = lead?.status_color || "slate";
  const cfg = COLOR_MAP[color] || COLOR_MAP.slate;
  return (
    <span
      data-testid={`status-chip-${lead.id}`}
      data-status={lead.status}
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full border font-medium whitespace-nowrap
                  ${cfg.bg} ${cfg.text} ${cfg.border}
                  ${size === "sm" ? "text-[11px]" : "text-[12px]"}`}
    >
      {label}
    </span>
  );
}
